export default {"src":"/_next/static/media/pannel_ticket_icon.9e5c62f7.svg","height":16,"width":15,"blurWidth":0,"blurHeight":0};